import { useStarterDashboardV2PageData } from '#src/app/pages/starterDashboardV2/pageContext';

type UseGrowPetitionReturn = ModelHookResult<{ shouldShowPromoteYourPetition: boolean }>;

export function useGrowPetition(): UseGrowPetitionReturn {
	const {
		data: { petition },
	} = useStarterDashboardV2PageData();
	const shouldShowPromoteYourPetition = petition.promotable;

	return {
		data: { shouldShowPromoteYourPetition },
	};
}
